export default __webpack_public_path__ + "static/media/lca.385e0ecb.png";